import { existingHeaders } from "./utils";

import { getUrl } from "utils/urls.js";
import { getAuthUrl } from "utils/env";

const forgotPasswordFormUrl = "/password/forgotten-password";
const forgottenPasswordVerifyTokenUrl = "/password/token/verification";
const resetPasswordUrl = "/password/reset";
const myIdSetPasswordUrl = getUrl("myIdSetPassword");

export const passwordService = {
  forgotPassword,
  checkToken,
  resetPassword,
  myIdSetPassword,
};

function forgotPassword({ email, ioBlackbox, recaptchaToken }) {
  const requestOptions = {
    method: "POST",
    headers: existingHeaders,
    body: JSON.stringify({ email, ioBlackbox, recaptchaToken }),
  };
  return fetch(getAuthUrl(forgotPasswordFormUrl), requestOptions);
}

function checkToken(token) {
  const requestOptions = {
    method: "POST",
    headers: existingHeaders,
    credentials: "same-origin",
    body: JSON.stringify({ token: token }),
  };
  return fetch(getAuthUrl(forgottenPasswordVerifyTokenUrl), requestOptions);
}

function resetPassword(token, new_password) {
  const requestOptions = {
    method: "PUT",
    headers: {
      ...existingHeaders,
    },
    credentials: "same-origin",
    body: JSON.stringify({ token, new_password }),
  };
  return fetch(getAuthUrl(resetPasswordUrl), requestOptions);
}

function myIdSetPassword(new_password) {
  const requestOptions = {
    method: "POST",
    headers: {
      ...existingHeaders,
    },
    credentials: "same-origin",
    body: JSON.stringify({ new_password }),
  };
  return fetch(getAuthUrl(myIdSetPasswordUrl), requestOptions);
}
